import { strapiClient } from "@shared/api";
import rebuild from "@shared/api/rebuild";

import {
  type CafesRestaurantsPageType,
  mapDtoToCafesRestaurantsBadgeTypes,
  mapDtoToCafesRestaurantsPage,
  mapDtoToCafesRestaurantsPoints,
  mapDtoToCafesRestaurantsTypes,
} from "../model";
import type {
  CafesRestaurantsBadgeType,
  CafesRestaurantsPoints,
  CafesRestaurantsType,
} from "../model/types";
import { searchParams } from "./params";

type DataType = {
  hero: CafesRestaurantsPageType;
  list: CafesRestaurantsPoints;
  filters: CafesRestaurantsType[];
  badges: CafesRestaurantsBadgeType[];
};

export const getCafesRestaurantsPage = async () => {
  const cafesRestaurantsPage = strapiClient.single("cafes-restaurants-page");
  const cafesRestaurantsPoints = strapiClient.collection(
    "cafes-restaurants-points",
  );
  const cafesRestaurantsTypes = strapiClient.collection(
    "cafes-restaurants-types",
  );
  const cafesRestaurantsBadgeTypes = strapiClient.collection(
    "cafes-restaurants-badge-types",
  );

  const page = await cafesRestaurantsPage.find({
    ...searchParams.page,
  });

  const points = await cafesRestaurantsPoints.find({
    ...searchParams.points,
  });

  const types = await cafesRestaurantsTypes.find({
    ...searchParams.types,
  });

  const badges = await cafesRestaurantsBadgeTypes.find({
    ...searchParams.types,
  });

  return rebuild({
    hero: mapDtoToCafesRestaurantsPage(page),
    list: mapDtoToCafesRestaurantsPoints(points),
    filters: mapDtoToCafesRestaurantsTypes(types),
    badges: mapDtoToCafesRestaurantsBadgeTypes(badges),
    seo: page?.data?.seo || {},
  }) as DataType;
};
